module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-1-50.785b4e75.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-1-50.png
// module id = 2551
// module chunks = 11